document.addEventListener("DOMContentLoaded", function () {
  const icebathComboOptions = document.querySelectorAll(
    ".icebath-combo-option"
  );

  icebathComboOptions.forEach((item) => {
    item.addEventListener("click", (e) => {
      const target = e.currentTarget;
      const { value } = target.dataset;

      console.log("Name", value.toLowerCase());

      const whiteOption = document.querySelector(".white-option");
      const blackOption = document.querySelector(".black-option");
      const timberOption = document.querySelector(".timber-option");

      const lowerCaseValue = value.toLowerCase();

      if (lowerCaseValue.includes("signature")) {
        if (timberOption) timberOption.parentElement.setAttribute("style", "display: none");
        if (whiteOption) whiteOption.parentElement.removeAttribute("style");
        if (blackOption) blackOption.parentElement.removeAttribute("style");
      } else if (lowerCaseValue.includes("xl")) {
        if (timberOption) timberOption.parentElement.setAttribute("style", "display: none");
        if (blackOption) blackOption.parentElement.setAttribute("style", "display: none");
        if (whiteOption) whiteOption.parentElement.removeAttribute("style");
      } else if (lowerCaseValue.includes("nest")) {
        if (timberOption) timberOption.parentElement.removeAttribute("style");
        if (whiteOption) whiteOption.parentElement.setAttribute("style", "display: none");
        if (blackOption) blackOption.parentElement.removeAttribute("style");
      }

      // Click the first visible color option after a delay
      setTimeout(() => {
        const colorOptions = [whiteOption, blackOption, timberOption];
        const firstVisible = colorOptions.find(
          (opt) => opt && opt.parentElement.style.display !== "none"
        );
        if (firstVisible) firstVisible.click();
      }, 600);
    });
  });
});
